import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { SubCategory } from '../types/sub-category.type';
import { UpdateSubCategoryRequestDTO } from '../types/dtos/update-sub-category.dto';
import { ADMIN_SUB_CATEGORIES_API_PATHS } from '../constants/sub-categories-api-paths.constants';

type UpdateSubCategoryParams = {
  subCategoryId: string;
  subCategoryData: UpdateSubCategoryRequestDTO;
};

type UseUpdateSubCategoryResult = {
  updateSubCategory: (params: UpdateSubCategoryParams) => Promise<SubCategory | null>;
  isSubmitting: boolean;
};

export function useUpdateSubCategory(): UseUpdateSubCategoryResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateSubCategory = async ({
    subCategoryId,
    subCategoryData,
  }: UpdateSubCategoryParams): Promise<SubCategory | null> => {
    setIsSubmitting(true);

    try {
      const updated = await HttpClient.patch<SubCategory, UpdateSubCategoryRequestDTO>(
        ADMIN_SUB_CATEGORIES_API_PATHS.UPDATE_SUB_CATEGORY(subCategoryId),
        subCategoryData
      );

      enqueueSnackbar('La sous-rubrique a été mise à jour', { variant: 'success' });
      return updated;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour de la sous-rubrique'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updateSubCategory, isSubmitting };
}
